import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BookingConceptService } from './booking-concept.service';

export interface BookingConceptSyncDialogData {
  conceptUid: string;
  conceptName: string;
}

@Component({
  selector: 'app-booking-concept-sync-dialog',
  templateUrl: './booking-concept-sync-dialog.component.html',
  styleUrls: ['./booking-concept-sync-dialog.component.css'],
  standalone: false
})
export class BookingConceptSyncDialogComponent implements OnInit {
  loading = true;
  saving = false;
  error: string = null;

  form = new UntypedFormGroup({
    factuName:         new UntypedFormControl(''),
    factuDescription:  new UntypedFormControl(''),
    factuPrice:        new UntypedFormControl(''),
    bookitTitle:       new UntypedFormControl(''),
    bookitDescription: new UntypedFormControl(''),
    bookitPrice:       new UntypedFormControl(''),
    bookitDuration:    new UntypedFormControl('')
  });

  rows: Array<{ locationId: string; name: string; checkControl: UntypedFormControl }> = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: BookingConceptSyncDialogData,
    private dialogRef: MatDialogRef<BookingConceptSyncDialogComponent>,
    private bookingConceptService: BookingConceptService
  ) {}

  ngOnInit(): void {
    this.bookingConceptService.getSyncStatus(this.data.conceptUid).subscribe({
      next: (status) => {
        this.form.patchValue({
          factuName:        status.factuProfile.name        || '',
          factuDescription: status.factuProfile.description || '',
          factuPrice:       status.factuProfile.price != null ? String(status.factuProfile.price) : '',
          bookitTitle:       status.bookitProfile?.title       || status.factuProfile.name        || '',
          bookitDescription: status.bookitProfile?.description || status.factuProfile.description || '',
          bookitPrice:       status.bookitProfile?.price != null
                               ? String(status.bookitProfile.price)
                               : (status.factuProfile.price != null ? String(status.factuProfile.price) : ''),
          bookitDuration:    status.bookitProfile?.durationMinutes != null
                               ? String(status.bookitProfile.durationMinutes)
                               : '60'
        });

        const activeIds = new Set(
          (status.assignments || []).filter(a => a.active).map(a => a.locationId)
        );
        this.rows = (status.locations || []).map(loc => ({
          locationId: loc.locationId,
          name: loc.name,
          checkControl: new UntypedFormControl(activeIds.has(loc.locationId))
        }));

        this.loading = false;
      },
      error: () => {
        this.error = 'Error cargando el estado de sincronización.';
        this.loading = false;
      }
    });
  }

  copyNameToBookit():    void { this.form.get('bookitTitle').setValue(this.form.get('factuName').value); }
  copyNameFromBookit():  void { this.form.get('factuName').setValue(this.form.get('bookitTitle').value); }
  copyDescToBookit():    void { this.form.get('bookitDescription').setValue(this.form.get('factuDescription').value); }
  copyDescFromBookit():  void { this.form.get('factuDescription').setValue(this.form.get('bookitDescription').value); }
  copyPriceToBookit():   void { this.form.get('bookitPrice').setValue(this.form.get('factuPrice').value); }
  copyPriceFromBookit(): void { this.form.get('factuPrice').setValue(this.form.get('bookitPrice').value); }

  save(): void {
    this.saving = true;
    const durRaw = this.form.get('bookitDuration').value;
    const dur    = durRaw !== null && durRaw !== '' && !isNaN(Number(durRaw)) ? Number(durRaw) : 60;

    this.bookingConceptService.sync(this.data.conceptUid, {
      assignments:     this.rows.filter(r => r.checkControl.value).map(r => ({ locationId: r.locationId })),
      title:           this.form.get('bookitTitle').value       || undefined,
      description:     this.form.get('bookitDescription').value || undefined,
      price:           this.form.get('bookitPrice').value       ? Number(this.form.get('bookitPrice').value) : undefined,
      durationMinutes: dur,
      factuName:        this.form.get('factuName').value        || undefined,
      factuDescription: this.form.get('factuDescription').value || undefined,
      factuPrice:       this.form.get('factuPrice').value       ? Number(this.form.get('factuPrice').value) : undefined
    }).subscribe({
      next: () => {
        this.saving = false;
        this.dialogRef.close(true);
      },
      error: () => {
        this.saving = false;
        this.error = 'Error al sincronizar. Inténtalo de nuevo.';
      }
    });
  }

  cancel(): void { this.dialogRef.close(false); }
}
